import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
let LocationDesign = class LocationDesign extends Vue {
    // @Prop({default:{}})
    // opts!:any
    render(h) {
        return h('a-input', { props: {
                disabled: true,
                placeholder: "请输入"
            } }, [
            h("i", {
                props: {
                    type: "user"
                },
                slot: 'suffix',
                'class': [
                    'aufontAll',
                    'h-icon-all-position-o'
                ]
            })
        ]);
    }
};
LocationDesign = tslib_1.__decorate([
    Component({ name: 'LocationDesign' })
], LocationDesign);
export default LocationDesign;
